import { OverlayRef } from '@angular/cdk/overlay';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  computed,
  inject,
  input,
  model,
  signal,
  OnInit,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ButtonComponent } from '@modules/components/button/button.component';
import { SearchFieldComponent } from '@modules/components/search-field/search-field.component';
import { FilterHelperService } from '@modules/filter/services/filter-helper/filter-helper.service';
import { FilterRow } from '@type/filter.type';
import { FilterRowComponent } from '../filter-row/filter-row.component';

type Tab = {
  value: any;
  name: string;
};

@Component({
  selector: 'app-filter-side-bar',
  imports: [SearchFieldComponent, MatIconModule, ButtonComponent, FilterRowComponent],
  templateUrl: './filter-side-bar.component.html',
  styleUrl: './filter-side-bar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilterSideBarComponent implements OnInit {
  private filterHelper = inject(FilterHelperService);

  private cdr = inject(ChangeDetectorRef);

  overlayRef = input.required<OverlayRef>();

  options = this.filterHelper.options;

  tabs: Tab[] = [];

  get showTabs() {
    return this.tabs.length > 1;
  }

  fields = signal<FilterRow[]>([]);

  viewFields = computed(() =>
    this.fields().filter((f) => f.localized_name.toLocaleLowerCase().includes(this.query().toLocaleLowerCase())),
  );

  query = model('');

  ngOnInit(): void {
    this.throwOptionRequiredError();
    this.tabs = this.getTabs();
    this.initFields(this.tabs);
  }

  detachBar() {
    this.overlayRef().detach();
    this.cdr.detectChanges();
  }

  selectFilterFields({ value }: Tab) {
    this.fields.set(value);
  }

  private throwOptionRequiredError() {
    if (this.options == null) throw '[options] input is required';
  }

  private getTabs() {
    return this.options().rows.map((f) => ({ name: f.name, value: f.fields }));
  }

  private initFields(tabs: Tab[]) {
    !!tabs[0] && this.selectFilterFields(tabs[0]);
  }
}
